import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplicationPermissionsModel } from "../../../common/models/permissions/ApplicationPermissionsModel";
import { ApiDataService } from "../ApiDataService";

@Injectable()
export class PermissionsDataService extends ApiDataService {
    constructor() {
        super("permissions");
    }

    public getPermissions(): Observable<ApplicationPermissionsModel> {
        return this.get<ApplicationPermissionsModel>();
    }
}
